const language = navigator && navigator.language;
const notInClient = language.includes('zh')
    ? '不在客户端环境内'
    : 'Not In Client';
const timeoutInClient = language.includes('zh')
    ? '客户端通信超时'
    : 'client call timeout';
const callbacks = (window.G2_callbacks = {
    _id: 0,
    _getId() {
        return this._id++;
    },
});
/**
 * [2022-05-31]
 * 注：使用 StringReadonlyDictionary 来代替 as const 让属性只读属性
 */
const jsBridgeMap = {
    ios: 'WebViewJavascriptBridge',
    android: 'XLJSWebViewBridge',
    account: 'XLAccountJsBridge',
    mac: 'WebViewJavascriptBridge',
    pc: 'native',
    xbase: 'XBaseObject',
};
const handleMap = {
    ios: 'callHandler',
    android: 'sendMessage',
    account: 'callFunction',
    mac: 'callHandler',
    pc: 'CallNativeFunction',
    xbase: 'call',
};
export function sendMessage(nativeCallParams, config) {
    const platform = nativeCallParams['platform'];
    const params = 'params' in nativeCallParams ? nativeCallParams['params'] : null;
    const method = handleMap[platform];
    const jsBridge = jsBridgeMap[platform];
    if (!window[jsBridge]) {
        // eslint-disable-next-line
        return Promise.reject(notInClient);
    }
    let { isCallBack = false, callbackTimeout = 5000, noCallback = false, } = Object.assign({}, config);
    // ios, mac 和 pc 默认支持回调函数
    if (['ios', 'mac', 'pc'].includes(platform))
        isCallBack = true;
    const clientPromise = new Promise((resolve, _) => {
        if (isCallBack) {
            let paramsList = [nativeCallParams.name];
            if (params) {
                paramsList.push(params);
            }
            else {
                paramsList.push({});
            }
            paramsList.push((...args) => {
                resolve(args);
            });
            window[jsBridge][method](...paramsList);
        }
        else {
            let preparedParamList = [nativeCallParams.name];
            if (platform === 'xbase') {
                preparedParamList = [
                    JSON.stringify(nativeCallParams.context),
                    nativeCallParams.module,
                    nativeCallParams.name,
                ];
            }
            const callbackKey = '_callback_' + callbacks._getId() + '_' + nativeCallParams.name;
            const callbackName = 'G2_callbacks.' + callbackKey;
            callbacks[callbackKey] = function (args) {
                callbacks[callbackKey] = null;
                window[callbackName] = null;
                if (['[object Object]', '[object Array]'].includes(Object.prototype.toString.call(args))) {
                    resolve(args);
                }
                else {
                    try {
                        const data = JSON.parse(args);
                        resolve(data);
                    }
                    catch (err) {
                        resolve(args);
                    }
                }
            };
            if (params) {
                preparedParamList.push(JSON.stringify(params));
            }
            else {
                preparedParamList.push(JSON.stringify({}));
            }
            const gCallbackName = 'window.' + callbackName;
            preparedParamList.push(gCallbackName);
            window[jsBridge][method](...preparedParamList);
        }
    });
    // TODO (和兴广确认): noCallback 是不是可以前置判断？？
    // 我看到很多代码都直接设置为 true，那么如果是 true，那 callbackTimeout 的判断就没有意义
    const noTimeout = callbackTimeout === 0 || noCallback;
    return Promise.race([
        clientPromise,
        !noTimeout &&
            promiseTimeOut(callbackTimeout, `${nativeCallParams.name}-${timeoutInClient}`),
    ]);
}
function promiseTimeOut(time, reason = '') {
    return new Promise((_resolve, reject) => {
        setTimeout(() => {
            reject(reason);
        }, time);
    });
}
const handleEventOnMap = {
    mac: 'addEventListener',
    pc: 'AttachNativeEvent',
};
const handleEventOffMap = {
    mac: 'removeEventListener',
    pc: 'DetachNativeEvent',
};
export function onMessage(nativeCallEvents) {
    const platform = nativeCallEvents['platform'];
    const jsBridge = jsBridgeMap[platform];
    const method = handleEventOnMap[platform];
    if (!window[jsBridge]) {
        // eslint-disable-next-line
        return Promise.reject(notInClient);
    }
    const args = [nativeCallEvents.name, nativeCallEvents.callback];
    return window[jsBridge][method](...args);
}
export function offMessage(nativeCallEventsOff) {
    const platform = nativeCallEventsOff['platform'];
    const jsBridge = jsBridgeMap[platform];
    const method = handleEventOffMap[platform];
    if (!window[jsBridge]) {
        // eslint-disable-next-line
        return Promise.reject(notInClient);
    }
    const args = [nativeCallEventsOff.name, nativeCallEventsOff.eventId];
    return window[jsBridge][method](...args);
}
const handleEventCheckMap = {
    mac: 'checkFunction',
    ios: 'checkFunction',
    pc: 'CheckNativeFunction',
};
export function checkMessage(nativeCallEventsCheck) {
    const platform = nativeCallEventsCheck['platform'];
    const jsBridge = jsBridgeMap[platform];
    const method = handleEventCheckMap[platform];
    return new Promise((resolve, reject) => {
        if (!window[jsBridge]) {
            // eslint-disable-next-line
            reject(notInClient);
        }
        const paramsList = [nativeCallEventsCheck.name];
        paramsList.push((args) => {
            resolve(args);
        });
        window[jsBridge][method](...paramsList);
    });
}
//# sourceMappingURL=data:application/json;base64,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